import { Toggle } from "@/components/Toggle";
import { useConfigService } from "@/pages/configuration/useConfigService";
import { useTrans } from "@/translations";

import { useMemo } from "react";

import { twMerge } from "tailwind-merge";

import {
  CONTAMINATION_LEADERBOARD_TAB,
  GENERAL_WASTE_LEADERBOARD_TAB,
  RECYCLING_RATE_LEADERBOARD_TAB,
  SUBTITLES,
} from "../constants";
import { type Direction, Metric } from "../types";

type Props = {
  metric: Metric;
  setMetric: (value: Metric) => void;
  direction: Direction;
  hideFullRate: boolean;
  setHideFullRate: (value: boolean) => void;
};

export const TabsWithSubtitle: React.FC<Props> = ({
  metric,
  setMetric,
  direction,
  hideFullRate,
  setHideFullRate,
}) => {
  const { t } = useTrans();

  const { terminalConfig } = useConfigService();

  const tabs = useMemo(() => {
    const tabsList = [
      RECYCLING_RATE_LEADERBOARD_TAB,
      GENERAL_WASTE_LEADERBOARD_TAB,
    ];

    if (!!terminalConfig?.enableContaminationRegistration) {
      tabsList.push(CONTAMINATION_LEADERBOARD_TAB);
    }

    return tabsList;
  }, [terminalConfig]);

  return (
    <>
      <div className="border-grey2 mt-[14px] flex gap-[16px] border-b">
        {tabs.map((tab) => {
          const active = metric === tab.key;

          return (
            <button
              key={tab.key}
              onClick={() => setMetric(tab.key)}
              className={twMerge(
                "-mb-px cursor-pointer border-b-2 pb-[7px] text-[13px]",
                active
                  ? "border-black font-bold text-black"
                  : "text-grey5 border-transparent font-semibold",
              )}
            >
              {t(tab.label)}
            </button>
          );
        })}
      </div>

      <div className="mt-[3.3px] flex flex-wrap items-center justify-between gap-3">
        <p className="text-grey6 text-[12.5px]">
          {t(SUBTITLES[metric][direction])}
        </p>

        {metric === Metric.RECYCLING_RATE && (
          <Toggle
            checked={hideFullRate}
            onChange={setHideFullRate}
            label={t("homePage:leaderboardHideOutliers")}
            labelClassName="text-[12px] font-semibold text-black mx-[9px]"
            width={32}
            height={18}
            handleDiameter={12}
            offColor="#fff"
            onColor="#E7EB5D"
            offHandleColor="#C9C1C1"
            onHandleColor="#1D1C1C"
            trackBorderColor="#DAD3D3"
            trackBorderColorChecked="#1D1C1C"
          />
        )}
      </div>
    </>
  );
};
